const Page = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return <div className="page">{children}</div>
}

export default Page
